<template>
    <div class="ion-page">
        <ion-header>
        <ion-toolbar>
            <ion-buttons v-slot: start>
            <ion-menu-button></ion-menu-button>
            </ion-buttons>
            <ion-title>Chargers List</ion-title>
            <ion-buttons slot="end">
            <ion-button @click="addCharger" v-if="rightToAdd" class="hdrBtn">
                <ion-icon v-slot: start :icon="add"></ion-icon>&nbsp;Add New Charger
                <!-- <ion-icon slot="icon-only" name="add"></ion-icon>  class="btn-add" -->
            </ion-button>
            </ion-buttons>
        </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
        <Chargers />
        </ion-content>
    </div>
</template>
<script>
import { defineComponent } from "vue";
import Chargers from "@/components/admin/Chargers.vue";
import { AppUtils } from "@/util/app-utils";
import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonMenuButton, IonToolbar } from '@ionic/vue';
import { add } from 'ionicons/icons';

export default defineComponent({
    name:  'chargers',
    components: {
        Chargers, IonHeader, IonToolbar, IonButtons, IonMenuButton, IonButton, IonIcon, IonContent
    },
    data() {
        return {
            add,
            rightToAdd: false
        }
    },
    mounted() {
        this.rightToAdd = new AppUtils().getUserAccess("40|C");
    },
    methods: {
        addCharger() {
        this.$router.push("/admin/chargers/charger");
        },
    }
})
</script>
